import { Link } from "react-router-dom";
import { ThunderboltOutlined } from "@ant-design/icons";

const MachineCard = ({ machine, department, startTime }) => {
  const statusColor =
    machine.status === "active" ? "text-green-500" : machine.status === "maintenance" ? "text-yellow-500" : "text-red-500";
  const statusText =
    machine.status === "active"
      ? "Aktif"
      : machine.status === "maintenance"
      ? "Bakımda"
      : "Pasif";

  const formattedStartTime = startTime
    ? new Date(startTime).toLocaleTimeString("en-GB", {
        timeZone: "UTC", // Zaman dilimini sabitler
        hour: "2-digit",
        minute: "2-digit",
      })
    : "Bilgi Yok";

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <Link to={`/machines/${machine._id}`} className="block">
      <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-transform duration-300 ease-in-out transform hover:scale-105 p-4 w-56 relative">
        {/* Üst Bölüm - Başlık ve Menü */}
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center text-lg font-semibold text-gray-700">
            <ThunderboltOutlined className="text-gray-700 mr-2" />
            {machine.name.length > 15
              ? `${machine.name.slice(0, 15)}...`
              : machine.name}
          </div>
        </div>

        {/* Alt Bölüm - Makine Bilgileri */}
        <div className="space-y-2 text-gray-600 text-sm">
          {[
            { label: "Durum", value: statusText, className: statusColor },
            { label: "Makine Kodu", value: machine.code },
            { label: "Lokasyon", value: machine.location },
            {
              label: "Departman",
              value: truncateText(department?.name || "Departman Yok", 17),
            },
            {
              label: "Makine Yılı",
              value: machine.machineYear,
            },
            {
              label: "Başlangıç Saati",
              value: <span className="font-bold">{formattedStartTime}</span>,
            },
          ].map((item, index) => (
            <div key={index} className="flex justify-between">
              <span>{item.label}:</span>
              <span className={item.className || ""}>{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </Link>
  );
};

export default MachineCard;
